import beb from "../../assets/beb.png";
import crckd from "../../assets/crckdshed.png";
import daysnite from "../../assets/daysnite.png";
import getcrib from "../../assets/getcrib.png";
import helpmeout from "../../assets/helpmeout.webp";
import lavender from "../../assets/lavender.png";
import nitoo from "../../assets/nitoo.png";
import palaava from "../../assets/palaava.png";
import sportycam from "../../assets/sportycam.png";

export const projectarr = [
  {
    id: 0,
    title: "SportyCam",
    live: "https://www.sportycam.com/",
    ios: "https://apps.apple.com/ng/app/sportycam/id6756612199",
    description: "Sports club discovery and membership mobile app",
    stack: "REACT NATIVE + TYPESCRIPT + FIREBASE",
    snippet: sportycam,
    type: "mobile",
  },
  {
    id: 1,
    title: "Lavenderlane",
    live: "https://www.lavenderlaneinternational.com/",
    description:
      "Marketing site for a couples app featuring date nights, AI relationship counselling, games, and intimacy",
    stack: "NEXTJS + FRAMER MOTION",
    snippet: lavender,
  },
  {
    id: 2,
    title: "Palaava",
    live: "https://www.palaava.com/",
    description: "SaaS landing page and complete dispute resolution system",
    stack: "NEXTJS + TYPESCRIPT + FRAMER MOTION",
    snippet: palaava,
  },
  {
    id: 3,
    title: "BE Euphoria Beauty",
    live: "https://www.beuphoriabeauty.com/",
    description:
      "Full ecommerce store for a Nigerian premium skincare and cosmetics brand ",
    stack: "NEXTJS + TYPESCRIPT + ZUSTAND + SUPABASE",
    snippet: beb,
  },
  {
    id: 4,
    title: "Days & Nites",
    live: "https://daysnites.com/",
    description:
      "Creative agency website for a video production, content strategy, and development studio",
    stack: "VITE + TYPESCRIPT + TAILWIND + GSAP",
    snippet: daysnite,
  },
  {
    id: 5,
    title: "Nitoo Sanitary",
    live: "https://nitoosanitary.com/",
    description:
      "Corporate website for a leading Nigerian ceramic sanitary ware manufacturer",
    stack: "NEXTJS + TYPESCRIPT",
    snippet: nitoo,
  },
  {
    id: 6,
    title: "GetCrib",
    live: "https://getcrib.co",
    description: "Apartment rental platform",
    stack: "NEXTJS + TYPESCRIPT + REDUX",
    snippet: getcrib,
  },
  {
    id: 7,
    title: "crckd arcade",
    live: "https://game-lobby-system-fe.vercel.app/register",
    description: "Mini game lobby for frontend assessment",
    stack: "VITE + TYPESCRIPT + EXPRESS",
    snippet: crckd,
  },
  {
    id: 8,
    title: "helpmeout",
    description: "Screen recording chrome extension plugin",
    stack: "JAVASCRIPT + CHROME SCREEN CAPTURE API",
    github: "https://github.com/shadrxcc/HelpMeOut-ext",
    snippet: helpmeout,
  },
];
